<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Saldo Awal - Barang</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small"> Keuangan / Master / Saldo Awal / Barang</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          :loading="isLoadingSave"
          icon="pi pi-plus"
          label="Saldo Awal - Barang"
          class="mr-2"
          @click="onShowDialog"
        />
        <Button
          :loading="isLoadingTemplateImport"
          icon="pi pi-download"
          label="Template"
          class="p-button-success mr-2"
          @click="downloadTemplate"
        />
        <FileUpload
          :loading="isLoadingImport"
          type="file"
          name="file"
          icon="pi pi-upload"
          class="p-button mr-2"
          chooseLabel="Import"
          mode="basic"
          :customUpload="true"
          @uploader="importFile"
          :maxFileSize="10000000"
        />
        <Button
          :loading="isLoadingExportExcel"
          icon="pi pi-file-excel"
          label="Export"
          class="p-button-outlined mr-2"
          @click="exportDataExcel"
        />
        <Button
          :loading="isLoadingExportPdf"
          icon="pi pi-print"
          label="Print"
          class="p-button-outlined"
          @click="exportDataPdf"
        />
      </div>
      <grid-barang
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        @request="onRequestData"
        @edit="onEditDialog"
      />
    </div>
    <Dialog
      :header="
        form && form.id > 0
          ? 'Edit Saldo Awal Barang'
          : 'Tambah Saldo Awal Barang'
      "
      v-model:visible="dialogSave"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
    >
      <form-barang
        :item="form"
        :loading="isLoadingSave"
        @save="onSaveData"
        @close="dialogSave = false"
      />
    </Dialog>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <div>
        <embed
          :src="pdfSource"
          type="application/pdf"
          width="100%"
          height="600px"
        />
      </div>
      <template #footer>
        <Button
          type="button"
          label="Download"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadPdf"
        />
        <Button
          type="button"
          label="Print"
          icon="pi pi-print"
          @click="onPrintPdf"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import SaldoAwalBarangService from '@/services/SaldoAwalBarangService'
import errorHandler from '@/helpers/error-handler'
import GridBarang from '@/components/keuangan/saldo/GridBarang'
import FormBarang from '@/components/keuangan/saldo/FormBarang'
import ObatService from '@/services/ObatService'
import { saveAs } from 'file-saver'

export default {
  components: {
    GridBarang,
    FormBarang,
  },
  data() {
    return {
      dataService: null,
      dialogSave: false,
      dialogViewer: false,
      faktur: 0,
      pdfSource: '',
      pdfTitle: 'PDF Viewer',
      pdfFilename: '',
      isLoading: false,
      isLoadingSave: false,
      isLoadingExportPdf: false,
      isLoadingExportExcel: false,
      isLoadingImport: false,
      isLoadingTemplateImport: false,
      items: [],
      form: {
        id: 0,
        obat: { kode: '', nama: '' },
        obat_id: 0,
        quantity: 0,
        batch_no: null,
        expired_at: null,
        harga: 0,
      },
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: 'nama',
        sortOrder: 1,
        filters: null,
      },
    }
  },
  created() {
    this.dataService = new SaldoAwalBarangService()
  },
  mounted() {
    this.onLoadGridData()
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.onLoadGridData()
    },
    onLoadGridData() {
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.isLoading = true
      this.dataService
        .paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data.data
          this.totalRecords = res.data.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Saldo Awal Barang', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onShowDialog(data) {
      this.form = Object.assign({}, data)
      this.dialogSave = true
    },
    async onEditDialog(item) {
      const obatService = new ObatService()
      const obat = await obatService.get(`/${item.obat_id}`).then((res) => {
        if (res.data.status === 200) {
          return {
            id: item.obat_id,
            nama: res.data.data.nama,
            kode: res.data.data.kode,
          }
        }
      })
      item.obat = obat
      this.form = Object.assign({}, item)
      this.form.expired_at = this.form.expired_at
        ? new Date(this.form.expired_at)
        : null
      this.dialogSave = true
    },
    onSaveData(data) {
      let item = {}
      item.kode_obat = data.kode
      item.nama = data.nama
      item.batch_no = data.batch_no
      item.expired_at = dayjs(data.expired_at).format('YYYY-MM-DD')
      item.quantity = data.quantity
      item.harga = data.harga

      this.isLoadingSave = true
      if (data.id > 0) {
        this.dataService
          .update(item, data.id)
          .then((res) => {
            if (res.data.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Saldo Awal Barang',
                detail: 'Saldo Awal Barang berhasil diperbarui.',
                life: 3000,
              })
              this.onLoadGridData()
              this.dialogSave = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Saldo Awal Barang', this)
          })
          .finally(() => (this.isLoadingSave = false))
      } else {
        this.dataService
          .add(item)
          .then((res) => {
            if (res.data.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Saldo Awal Barang',
                detail: 'Saldo Awal Barang berhasil ditambahkan.',
                life: 3000,
              })
              this.onLoadGridData()
              this.dialogSave = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Saldo Awal Barang', this)
          })
          .finally(() => (this.isLoadingSave = false))
      }
    },
    exportDataPdf() {
      this.isLoadingExport = true
      this.dataService
        .exportPdf()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Export Saldo Awal Barang',
              detail: 'Gagal mengunduh Saldo Awal Barang.',
              life: 3000,
            })
          } else {
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const pdfUrl = URL.createObjectURL(blob)
            this.pdfSource = pdfUrl + '#toolbar=0'
            this.pdfFilename = `saldo-awal-barang.pdf`
            this.pdfTitle = 'PDF Viewer (' + this.pdfFilename + ')'
            this.dialogViewer = true
          }
        })
        .catch((err) => {
          errorHandler(err, 'Export Saldo Awal Barang', this)
        })
      this.isLoadingExportPdf = false
    },
    onPrintPdf() {
      const iframe = document.createElement('iframe')
      iframe.src = this.pdfSource
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      // Use onload to make pdf preview work on firefox
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    onDownloadPdf() {
      saveAs(this.pdfSource, this.pdfFilename)
    },
    exportDataExcel() {
      this.isLoadingExportExcel = true
      this.dataService
        .exportExcel()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Export Saldo Awal Barang',
              detail: 'Gagal mengunduh Saldo Awal Barang.',
              life: 3000,
            })
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'saldo-awal-barang.xls')
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Export Saldo Awal Barang', this)
        })
        .finally(() => (this.isLoadingExportExcel = false))
    },
    importFile(event) {
      this.isLoadingImport = true
      this.dataService
        .import(event.files[0])
        .then((res) => {
          if (res.data.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Import File Saldo Awal Barang',
              detail: 'Berhasil import Saldo Awal Barang.',
              life: 3000,
            })
            this.onLoadGridData()
          } else {
            let msg = []
            res.data.data.forEach((value) => {
              msg.push(value.error)
            })
            this.$toast.add({
              severity: 'error',
              summary: `${res.data.message}`,
              detail: `${msg}`,
              life: 4000,
            })
          }
        })
        .catch((err) => {
          errorHandler(err, 'Import File Saldo Awal Barang', this)
        })
        .finally(() => (this.isLoadingImport = false))
    },
    downloadTemplate() {
      this.isLoadingTemplateImport = true
      this.dataService
        .templateImport()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Download Template Saldo Awal Barang',
              detail: 'Berhasil mengunduh Template Saldo Awal Barang.',
              life: 3000,
            })
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'saldo_barang.xls')
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Download Template Saldo Awal Barang', this)
        })
        .finally(() => (this.isLoadingTemplateImport = false))
    },
  },
}
</script>
